import React from "react";
import PropTypes from "prop-types";
import Loader from "../Components/Loading";

const ShowCaseLoading = ({ loading }) => {
    return (
        <div className="py-5">
            <Loader isLoading={loading} text="Please wait..." />
        </div>
    );
};

ShowCaseLoading.defaultProps = {
    loading: true
};

ShowCaseLoading.propTypes = {
    loading: PropTypes.bool
};

export default ShowCaseLoading;
